import { ProductFormBase } from './product-form-class.js';

import '../../styles/components/product-form.scss';
import '../../styles/components/checkbox.scss';

/*
 * This is a custom element that extends from the ProductFormBase class
 * Any custom logic for the product form that is unique to the main product form should be added here
 * Otherwise, it should be added to the ProductFormBase class
 */
class ProductMainFormElement extends ProductFormBase {
  constructor() {
    super();

    this.imageSwiper = this.productWrapper.querySelector("[data-product-image-swiper]");
    this.thumbsSwiper = this.productWrapper.querySelector("[data-product-thumbs-swiper]");

    this.inventoryStatus = this.productWrapper.querySelector('[data-inventory-status]'); // inventory status block

    this.specificationsLists = this.productWrapper.querySelectorAll('[data-specifications-variant-id]'); // inventory status block

    if (this.inventoryStatus) {
      this.inventoryLowStockPoint = this.inventoryStatus.dataset.lowStock;
      this.inventoryStock = this.inventoryStatus.querySelector('[data-inventory-stock]');
      this.inventoryStatusClasses = ['in-stock', 'low-stock', 'sold-out'];
      this.inventoryData = this.getInventoryData();
    }
  }

  getInventoryData() {
    return JSON.parse(this.productWrapper.querySelector('[data-inventory-data]').innerHTML);
  }

  // is called by the ProductFormBase class
  optionsChange(event) {
    let variant = event.dataset.variant;

    if (!variant) {
      let arrayOfValues = [];
      let foundVariant = false;
      // Triggered change values
      const triggerPosition = event.target.dataset.optionPosition
        ? parseInt(event.target.dataset.optionPosition) - 1
        : parseInt(event.target.dataset.optionPositionSelect) - 1;
      const triggerValue = event.dataset.options[triggerPosition].value;
      const productVariantOption = 'option' + (triggerPosition + 1);

      event.dataset.options.forEach((option, index) => {
        if (option.value.includes("(")) {
          const cleanedValue = option.value.split("(")[0] + "(";
          arrayOfValues[index] = cleanedValue;
        } else {
          arrayOfValues[index] = option.value;
        }
      });

      this.product.variants.forEach(productVariant => {
        if (foundVariant) return;

        if (arrayOfValues.length > 1) {
          arrayOfValues.forEach((item, index) => {
            if (foundVariant) return;

            const currentOption = 'option' + (index + 1);
            if (currentOption !== productVariantOption
              && productVariant[productVariantOption] == triggerValue
              && (productVariant[currentOption] == arrayOfValues[index] || (productVariant[currentOption].includes("(") && productVariant[currentOption].includes(arrayOfValues[index])))
              && productVariant.available
            ) {
              variant = productVariant;
              foundVariant = true;
            }
          });

          if (!foundVariant && (productVariant[productVariantOption] == triggerValue && productVariant.available)) {
            variant = productVariant;
            foundVariant = true;
          }
        } else {
          if (productVariant[productVariantOption] == triggerValue && productVariant.available) {
            variant = productVariant;
            foundVariant = true;
          }
        }
      });

      this.updateOtherOptions(variant);
    }

    window.dispatchEvent(new CustomEvent('variantChanged', { detail: variant.id }));

    this.updateBrowserHistory(variant);
    this.updateMainSelect(variant);
    this.updateProductPrice(variant);
    this.updateOutOfStockOptions(variant);
    this.updateSku(variant);
    this.updateSelectedOptions(variant);
    this.updateProductButton(variant);
    this.updateSlideImages(variant);
    this.updateQuantityRules(variant);

    if (this.specificationsLists) {
      this.updateSpecifications(variant);
    }

    if (this.inventoryStatus) {
      this.updateInventory(variant);
    }

    if (this.sellingPlanId) {
      this.updateVisibleSellingPlans(variant);
    }
  }

  updateSlideImages(variant) {
    if (variant && this.imageSwiper) {
      /**
       * Go to the variant featured image or first image.
       */
      if (variant.featured_media) {
        const imageId = variant.featured_media.id;
        const imageElement = this.imageSwiper.querySelector(`[data-media-id="${imageId}"]`);
        let imageIndex = [...Array.from(this.imageSwiper.querySelectorAll('.swiper-slide'))].indexOf(imageElement);

        if (imageIndex === -1) {
          imageIndex = 0;
        }

        this.imageSwiper.swiper.slideTo(imageIndex, 500);
      }
    }
  }

  updateInventory(variant) {
    this.inventoryStatus.classList.remove(...this.inventoryStatusClasses);

    if (variant) {
      this.inventoryStatus.classList.remove('hide');
      const variantInventoryData = this.inventoryData.variants[variant.id];
      const currentVariantQuantity = variantInventoryData.inventory_quantity;

      let classToAdd = 'in-stock';
      let forceSell = false;

      if (variantInventoryData.inventory_management != null && variantInventoryData.inventory_policy == "deny") {
        if (currentVariantQuantity < 2) {
          classToAdd = 'sold-out'
        } else if (currentVariantQuantity <= this.inventoryLowStockPoint && this.inventoryLowStockPoint !== 0) {
          classToAdd = 'low-stock'
        }
      } else {
        forceSell = true;
      }

      let quantityString = `: ${this.inventoryData.strings.quantity_other.replace('{{ count }}', currentVariantQuantity)}`;

      if (currentVariantQuantity == 1) {
        quantityString = `: ${this.inventoryData.strings.quantity_one.replace('{{ count }}', currentVariantQuantity)}`;
      }

      this.inventoryStatus.classList.add(classToAdd);

      if (this.inventoryStock) {
        this.inventoryStock.classList.toggle('hide', forceSell);
        this.inventoryStock.innerHTML = quantityString;
      }
    } else {
      this.inventoryStatus.classList.add('hide'); // hide inventory status if variant is invalid
    }
  }

  updateQuantityRules(variant) {
    if (variant && this.quantityInput) {
      this.quantityInput.max = variant.quantity_rule.max;
      this.quantityInput.min = variant.quantity_rule.min;
      this.quantityInput.step = variant.quantity_rule.increment;
      this.quantityInput.value = variant.quantity_rule.min;
    }
  }

  updateSpecifications(variant) {
    this.specificationsLists.forEach(list => {
      list.classList.toggle('hide', variant.id != list.dataset.specificationsVariantId);
    });
  }
}

try {
  customElements.define('product-main-form', ProductMainFormElement);
}
catch(e) {}
